import { SubmissionStatus } from '../components/ResultsPage/types';

/**
 * Determines the appropriate submission status based on the error type
 * @param error - The error object from the submission attempt
 * @returns SubmissionStatus.UNQUALIFIED if qualification error, otherwise SubmissionStatus.ERROR
 */
export const getSubmissionErrorStatus = (error: unknown): SubmissionStatus => {
  if (
    error instanceof Error &&
    error.message.includes('qualifications_not_met')
  ) {
    return SubmissionStatus.UNQUALIFIED;
  }
  return SubmissionStatus.ERROR;
};
